module.exports = __webpack_public_path__ + "static/media/klan.5fa2c40d.jpg";